import { TX } from '../registry/keys';
import type { TileXY } from '../types';

/** Authored farm layout (tile coordinates). Terrain lives in the Tiled JSON;
 *  these are the gameplay structures + regions the engine reasons about. */

export const MAP_WIDTH = 24;
export const MAP_HEIGHT = 20;

export interface Box {
  x: number;
  y: number;
  w: number;
  h: number;
}

/** Farmhouse — 48×40 placeholder, anchored by its top-left tile. Tap it to sleep. */
export const HOUSE = { tileX: 5, tileY: 2, wTiles: 3, hTiles: 3, texture: TX.house };
/** The door tile you approach to sleep (bottom-centre of the house). */
export const HOUSE_DOOR: TileXY = { x: HOUSE.tileX + 1, y: HOUSE.tileY + HOUSE.hTiles - 1 };

/** Pip's Stall — tap to buy seeds & decorations (2×2). */
export const SHOP = { x: 2, y: 10, wTiles: 2, hTiles: 2, texture: TX.shop };
export const SHOP_FRONT: TileXY = { x: SHOP.x + 1, y: SHOP.y + SHOP.hTiles - 1 };

/** Shipping bin — drop produce here; settled at day end. */
export const SHIPPING_BIN = { x: 10, y: 8, texture: TX.shippingBin };

/** Welcome sign — tap to read personalization.signText. */
export const SIGN = { x: 9, y: 12, texture: TX.sign };

/** Mailbox by the house — tap to collect Clara's daily gift. */
export const MAILBOX: TileXY = { x: 8, y: 4 };

/** Trail to the forest — tap to head out foraging. */
export const TRAIL: TileXY = { x: 20, y: 16 };

/** Tillable garden region (inclusive tile bounds). */
export const GARDEN: Box = { x: 11, y: 8, w: 8, h: 7 };

export const PLAYER_SPAWN: TileXY = { x: 9, y: 13 };
export const PET_SPAWN: TileXY = { x: 10, y: 14 };
export const CLARA_HOME: TileXY = { x: 8, y: 11 };

/** Where chickens hang out (left yard) and how far they roam. */
export const COOP: TileXY = { x: 3, y: 6 };
export const COOP_RADIUS = 3;

export function inGarden(x: number, y: number): boolean {
  return x >= GARDEN.x && x < GARDEN.x + GARDEN.w && y >= GARDEN.y && y < GARDEN.y + GARDEN.h;
}

function fill(out: TileXY[], x: number, y: number, w: number, h: number): void {
  for (let dx = 0; dx < w; dx++) for (let dy = 0; dy < h; dy++) out.push({ x: x + dx, y: y + dy });
}

/** Tiles permanently blocked by fixed structures (house, shop, bin, sign). */
export function structureBlockedTiles(): TileXY[] {
  const out: TileXY[] = [];
  fill(out, HOUSE.tileX, HOUSE.tileY, HOUSE.wTiles, HOUSE.hTiles);
  fill(out, SHOP.x, SHOP.y, SHOP.wTiles, SHOP.hTiles);
  out.push({ x: SHIPPING_BIN.x, y: SHIPPING_BIN.y });
  out.push({ x: SIGN.x, y: SIGN.y });
  out.push({ x: MAILBOX.x, y: MAILBOX.y });
  out.push({ x: TRAIL.x, y: TRAIL.y });
  return out;
}
